export enum HiringManagerStatus {
  SUBMIT = 'Submitted',
  ADVANCED = 'Advanced',
  REJECTED = 'Rejected',
}

export enum HiringManagerStatusFilter {
  SUBMITTED = 'Submitted',
  REJECTED = 'Rejected',
  ADVANCED = 'Advanced',
  NOT_SUBITTED = 'Not submitted',
}

export enum HiringManagerLabelUI {
  SUBMITTED = 'Submitted',
  REJECTED = 'Rejected by hiring manager',
  ADVANCED = 'Advanced by hiring manager',
  NOT_SUBITTED = 'Not submitted',
}
